import TrackResponseInterface from '@/webcomponents/f1-season/store/interface/track';

export default class Track implements TrackResponseInterface {
  id = 0;
  foreignId = '';
  name = '';
  city = '';
  grafic = '';
  length = '';
  rightTurns = '';
  leftTurns = '';
  address = '';
  internetAddress = '';
  ticketLink = '';
  description = '';
  debut = '';
  numberRaces = 0;
  lastWinners = '';
  firstVictory = '';
  firstPole = '';
  recordRace = '';
  recordQuali = '';
  driverWins = '';
  teamWins = '';
  driverPoles = '';
  teamPoles = '';
  driverPoints = '';
  teamPoints = '';
  seasonYear = '';
  seasonEvent: Array<string> = [];

  constructor (apiData: TrackResponseInterface) {
    Object.keys(apiData).forEach((apiDataKey: string) => {
      this[apiDataKey] = apiData[apiDataKey];
    });
  }
}
